import React from 'react';
import { MBChatInputMentionRow, MBChatInputMentionRowProps } from './row';

type MBChatInputMentionRowWithOnPressProps<T> = Omit<MBChatInputMentionRowProps, 'onPress'> & {
  item: T;
  onPress: (item: T) => void;
};

export class MBChatInputMentionRowWithOnPress<T> extends React.PureComponent<
  MBChatInputMentionRowWithOnPressProps<T>
> {
  onPress = () => this.props.onPress(this.props.item);
  render() {
    return <MBChatInputMentionRow {...this.props} onPress={this.onPress} />;
  }
}
